export default {
    route:{
        demo: 'My Demo'
    },
    project:{
        demo: {
            demoName: 'Demo Name',
            demoCode: 'Demo Code'
        },
        user:{
            userName: 'User Name',
            userLogin: 'User Login'
        },
        role:{
            roleName: 'Role Name'
        },
        goods:{
            addGoods: '+',
            subGoods: '-',
            setGoodsName:'Set Goods Name'
        },
        org:{
            routerList:'Get Org Router List'
        }
    },
    httpCode:{
        http404: '404 error'
    }
}